<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5.py-4.white
        v-row(no-gutters)
          v-col
            h6.basic800--text {{ $t('update_trackers') }}
      v-divider
          v-col.shrink
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              v-icon(color="white" :size="24") mdi-close
      v-card-text.pa-0
        v-form(ref="form")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          v-card.pa-4(v-else-if="!isFetching")
            .fb(v-if="type == 'fb'")
              p.mb-3.label.basic600--text.text-uppercase.mt-2 Facebook pixel ID
              v-text-field.mt-4(solo flat background-color="basic200"    height="40" v-model='tracker.fb'
                                outlined dense persistent-hint hide-details
                                :label="$t('facebook.label')"
                                :placeholder="$t('facebook.placeholder')"
                                :rules="rules.not_empty")

            .ga(v-if="type == 'ga'")
              p.mb-3.label.basic600--text.text-uppercase.mt-2 Google analytics tracking ID
              v-text-field.mt-4.p1(solo flat background-color="basic200"    height="40" v-model='tracker.ga'
                                outlined dense persistent-hint hide-details
                                :label="$t('google.label')"
                                :placeholder="$t('google.placeholder')"
                                :rules="rules.not_empty")

            .tiktok(v-if="type == 'tiktok'")
              p.mb-3.label.basic600--text.text-uppercase.mt-2 Tiktok pixel ID
              v-text-field.mt-4.p1(solo flat background-color="basic200"    height="40" v-model='tracker.tiktok'
                                outlined dense persistent-hint hide-details
                                :label="$t('tiktok.label')"
                                :placeholder="$t('tiktok.placeholder')"
                                :rules="rules.not_empty")
      v-divider
      v-card-actions
        v-spacer
        v-btn.button-AA-small(color='primary400', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.button-AA-small.mr-2.white--text(color='info500' depressed height=32 :loading="isLoading" @click='clickSave')
          | {{ $t('save') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'UpdateTrackers',
  props: ['open', 'company', 'type'],
  data: () => ({
    isFetching: true,
    tracker: {
      id: null,
      ga: '',
      fb: '',
      tiktok: '',
    },
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  created () {
    this.fetchSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchSettings () {
      this.$axios.get(`/trackers?company=${this.company.id}`).then((response) => {
        if (response.data.results.length>0) {
          this.tracker = response.data.results[0]
        }
        this.isFetching = false
      })
      .catch(() => {})
    },
    clickSave() {
      
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const params = {
        company: this.company.id,
      }
      if(this.type == 'fb'){
        params.fb = this.tracker.fb
      }
      if(this.type == 'ga'){
        params.ga = this.tracker.ga
      }
      if(this.type == 'tiktok'){
        params.tiktok = this.tracker.tiktok
      }
      if (this.tracker.id) {
        this.axios.put(`/trackers/${this.tracker.id}/`, params)
        .then(() => {
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/trackers/`, params)
        .then(() => {
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "update_trackers": "Update Tracking Code",
    "facebook": {
      "label": "Facebook Pixel Id",
      "placeholder": "Example: 1234567890123456"
    },
    "google": {
      "label": "Google Analytics Tracking Id",
      "placeholder": "Example: UA-12345678-9"
    }
  },
  "id": {
    "update_trackers": "Perbarui kode pelacakan",
    "facebook": {
      "label": "ID Facebook Pixel",
      "placeholder": "Example: 1234567890123456"
    },
    "google": {
      "label": "ID Google Analytics Tracking",
      "placeholder": "Example: UA-12345678-9"
    },
    "tiktok": {
      "label": "Tiktok Pixel Id",
      "placeholder": "Example: CABKTFBC77U2BL87PEAR"
    }
  }
}
</i18n>
